import * as React from "react";
import { styled } from "@mui/material/styles";
import { SxProps } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslate } from "ra-core";

export const Error = (props: ErrorProps) => {
  const { className, heading = "", children, ...rest } = props;

  const translate = useTranslate();
  return (
    <Root className={className} {...rest}>
      <div className={ErrorClasses.message}>
        <h1>{translate(heading, { _: heading })}</h1>
        <div>{children}</div>
      </div>
    </Root>
  );
};

Error.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  children: PropTypes.node,
};

export interface ErrorProps {
  className?: string;
  heading?: string;
  sx?: SxProps;
  children: React.ReactNode;
}

const PREFIX = "RaLoading";

export const ErrorClasses = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  message: `${PREFIX}-message`,
};

const Root = styled("div", {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.up("md")]: {
    height: "100%",
  },
  [theme.breakpoints.down("xl")]: {
    height: "100%",
    marginTop: "-3em",
  },
  [`& .${ErrorClasses.message}`]: {
    textAlign: "center",
    margin: "0 1em",
  },
}));
